(() => {
  if (customElements.get('amc-table-bulk')) return;
  class TableBulk extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const input = this.querySelector('input[name="quantity"]');
      const output = this.querySelector('output');
      const unit = Number(this.dataset.unitCents);
      if (!input || !output || !Number.isFinite(unit)) return;
      const currency = this.dataset.currency || 'USD';
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency
      });
      const quantity = () => {
        const value = Number(input.value);
        return Number.isFinite(value) ? Math.max(1, Math.floor(value || 1)) : 1;
      };
      const render = () => { output.textContent = money.format(unit * quantity() / 100); };
      input.addEventListener('input', render);
      input.addEventListener('change', () => {
        input.value = String(quantity());
        render();
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-table-step]');
        if (!button || !this.contains(button)) return;
        input.value = String(Math.max(1, quantity() + Number(button.dataset.tableStep)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      render();
    }
  }
  customElements.define('amc-table-bulk', TableBulk);
})();
